import { useEffect, useState } from "react";
import { menu as menuApi } from "../lib/api";
import { useNavigate } from "react-router-dom";

const CATEGORY_LABELS = {
  vodka: "Vodka",
  tequila: "Tequila",
  gin: "Gin",
  cognac: "Cognac",
  rum: "Rum",
  scotch: "Scotch",
  whiskey_bourbon: "Whiskey & Bourbon",
  champagne: "Champagne",
  other: "Other",
  packages: "Packages",
  ultra_experience: "Onyx Ultra Experience",
};

export default function MenuPreview() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState("tequila");
  const navigate = useNavigate();

  useEffect(() => { menuApi.list().then(setItems).catch(() => {}); }, []);

  const filtered = items.filter((i) => i.category === active).slice(0, 4);

  return (
    <section data-testid="menu-preview" className="relative py-28 md:py-36 bg-cream">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-8 mb-12">
          <div className="col-span-12 lg:col-span-5">
            <span className="eyebrow">— The Menu</span>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl mt-4 text-ink">Crafted to <span className="text-ink">elevate</span>.</h2>
          </div>
          <div className="col-span-12 lg:col-span-7 flex flex-wrap gap-2 lg:justify-end items-end">
            {Object.keys(CATEGORY_LABELS).map((k) => (
              <button
                key={k}
                data-testid={`menu-cat-${k}`}
                onClick={() => setActive(k)}
                className={`px-4 py-2 text-[10px] tracking-luxe uppercase border transition ${active === k ? "border-ink bg-ink text-white" : "border-black/15 text-muted hover:border-ink hover:text-ink"}`}
              >
                {CATEGORY_LABELS[k]}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-8">
          {filtered.length === 0 ? (
            <p className="font-display italic text-muted md:col-span-2 text-center py-8">More coming soon to this section.</p>
          ) : filtered.map((item) => (
            <div key={item.id} data-testid={`menu-item-${item.id}`} className="flex items-end justify-between gap-6 pb-5 border-b border-black/10 hover:border-gold transition">
              <div>
                <h4 className="font-display text-2xl md:text-3xl text-ink mb-1">{item.name}</h4>
                <p className="text-sm text-muted max-w-md">{item.description}</p>
                {item.coming_soon && <span className="inline-block mt-2 text-[10px] tracking-luxe uppercase text-gold">Coming Soon</span>}
              </div>
              <div className="font-display text-2xl text-gold whitespace-nowrap">${item.price.toFixed(0)}</div>
            </div>
          ))}
        </div>

        <div className="mt-14 flex justify-center">
          <button data-testid="menu-view-full" onClick={() => navigate("/menu")} className="btn-luxe btn-luxe-ghost">View Full Menu</button>
        </div>
      </div>
    </section>
  );
}
